// @ts-expect-error We haven't installed any types
import CryptoJS from 'crypto-js';

const STRING_UNDERSCORE_REGEXP_1 = /([a-z\d])([A-Z]+)/g;
const STRING_UNDERSCORE_REGEXP_2 = /-|\s+/g;

const STRING_CAMELIZE_REGEXP_1 = /(-|_|\.|\s)+(.)?/g;
const STRING_CAMELIZE_REGEXP_2 = /(^|\/)([A-Z])/g;

const STRING_DECAMELIZE_REGEXP = /([a-z\d])([A-Z])/g;

const STRING_DASHERIZE_REGEXP = /[ _]/g;

export function pluralize(count: number, string: string, pluralString: string) {
  if (count === 1) return string;
  return pluralString;
}

export function encrypt(value: string, secret: string) {
  return CryptoJS.AES.encrypt(value, secret).toString();
}

export function decrypt(value: string, secret: string) {
  const bytes = CryptoJS.AES.decrypt(value, secret);
  return bytes.toString(CryptoJS.enc.Utf8);
}

/**
 * @example
 *
 * underscore('innerHTML')
 * //=> 'inner_html'
 *
 * underscore('action_name')
 * //=> 'action_name'
 *
 * underscore('data-action')
 * //=> 'data_action'
 *
 * underscore('function works')
 * //=> 'function_works'
 */
export function underscore(value: string) {
  return value.replace(STRING_UNDERSCORE_REGEXP_1, '$1_$2').replace(STRING_UNDERSCORE_REGEXP_2, '_').toLowerCase();
}

/**
 * Returns the lowerCamelCase form of a string.
 *
 * @example
 *
 * camelize('innerHTML');
 * //=> innerHTML
 *
 * camelize('action_name');
 * //=> actionName
 *
 * camelize('css-class-name');
 * //=> cssClassName
 *
 * camelize('my favorite items');
 * //=> myFavoriteItems
 *
 * camelize('My Favorite Items');
 * //=> myFavoriteItems
 *
 * camelize('private-docs/owner-invoice');
 * //=> privateDocs/ownerInvoice
 */
export function camelize(value: string) {
  return value
    .replace(STRING_CAMELIZE_REGEXP_1, (_match, _separator, chr) => (chr ? chr.toUpperCase() : ''))
    .replace(STRING_CAMELIZE_REGEXP_2, (match) => match.toLowerCase());
}

/**
 * Replaces underscores, spaces, or camelCase with dashes.
 *
 * @example
 *
 * dasherize('innerHTML');
 * //=> inner-html
 *
 * dasherize('action_name');
 * //=> action-name
 */
export function dasherize(value: string): string {
  return decamelize(value).replace(STRING_DASHERIZE_REGEXP, '-');
}

/**
 * Converts a camelized string into all lower case separated by underscores.
 *
 * @example
 * decamelize('innerHTML');
 * //=> inner_html
 */
export function decamelize(value: string): string {
  return value.replace(STRING_DECAMELIZE_REGEXP, '$1_$2').toLowerCase();
}

/**
 * @example
 *
 * stripCSSUnit('18px')
 * //=> '18'
 */
export function stripCSSUnit(value: string) {
  return value.replace(/[^-\d.]/g, '');
}

/**
 * @description Parses a JSON string and returns the parsed value. If unsuccessful, default value is returned.
 * @example
 * const value = element.dataset.value // Assuming `value` is '{"user_id":"1"}'
 * parseJSON(value)
 * //=> { user_id: 1 }
 *
 * // Returns a default value if parsing was unsuccessful
 * parseJSON(undefined, [])
 * //=> []
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseJSON(value: any, defaultValue: unknown = '') {
  try {
    return JSON.parse(value);
  } catch {
    return defaultValue;
  }
}

export function convertToSlug(text: string) {
  return text
    .toLowerCase()
    .replace(/ /g, '-') // change spaces to hyphens
    .replace(/-+/g, '-') // collapse multiple hyphens
    .replace(/\s+/g, '-') // collapse multiple whitespace & replace by hyphens
    .replace(/[^\w-]+/g, ''); // replace anything not alphanumeric, underscore, or hyphen
}
